import fixWebmDuration from 'fix-webm-duration';

export async function withWebmDuration(blob, durationMs) {
  const type = blob?.type || '';
  if (!type.includes('webm') && !type.includes('weba')) return blob;
  if (!Number.isFinite(durationMs) || durationMs <= 0) return blob;

  try {
    return (await fixWebmDuration(blob, durationMs, { logger: false })) || blob;
  } catch (error) {
    console.warn('WebM duration patch skipped:', error?.message || error);
    return blob;
  }
}
